import * as React from 'react'
import { Link } from 'react-router-dom'

import { Button } from '../../../components'
import { InsiderView, InstOwnFiler } from '../constants'
import { useInsiderTradingRouter } from '../hooks/useInsiderTradingRouter'

type Props = Pick<InstOwnFiler, 'filerName' | 'otherManagerName' | 'filerCik'>

export function NoOwnHoldingsWarnings({ filerName, filerCik, otherManagerName }: Props) {
  const insiderTradingRouter = useInsiderTradingRouter<InsiderView.ManagerHoldings>()

  const managerLink = React.useMemo(
    () => (
      <Button
        as={Link}
        to={insiderTradingRouter.getInsiderTradingLink({
          view: InsiderView.ManagerDetails,
          params: { investorId: `${filerCik}`, reportEndDate: insiderTradingRouter.viewParams.reportEndDate },
        })}
        theme="link"
        align="left"
        size="none"
        className="inline-flex border-none"
        reloadDocument
      >
        {filerName}
      </Button>
    ),
    [filerName, filerCik, insiderTradingRouter]
  )

  return (
    <span className="inline-flex h-5 items-center whitespace-pre text-2xs text-muted-2">
      The 13F data for <strong>{otherManagerName}</strong> was filed under a 13F submission by {managerLink}.
    </span>
  )
}
